import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import PaginationTable from '../../PaginationTable';
import {formatDatetime, formatFloat, numberPadding } from '../../../../utils/formatting';


export default class AccompanimentBroker extends React.Component {

    constructor(props) {
        super(props);
        this.showDetail = this._showDetail.bind(this);
        this.hideDetail = this._hideDetail.bind(this);
        this.state = {
            showDetailFor : null
        }
    }

    _showDetail(report) {
        this.setState({
            showDetailFor : report,
        });
    }

    _hideDetail() {
        this.setState({
            showDetailFor : null,
        });
    }


    render() {
        const report = this.state.showDetailFor;
        return (
            <div className="table-responsive">
                <PaginationTable
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    {...this.props.data}
                    showDetail={this.showDetail}
                    pageChange={this.props.changePage}
                    headerComponent={renderHeader}
                    rowComponent={renderRow}/>

                <Modal isOpen={report !== null} toggle={this.hideDetail} bsSize="large">
                    <ModalHeader toggle={this.hideDetail}>
                        Detalle
                    </ModalHeader>
                    <ModalBody>
                        {
                            report !== null ?
                            <table className="table">
                                <tbody>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            1. Cartera de Crédito
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            Revisión de créditos colocados durante el mes
                                        </td>
                                        <td>
                                            {report.cart_credito}
                                        </td>
                                        <td>
                                            {formatFloat(report.cart_credito_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Revisión de número de prospectos y montos
                                        </td>
                                        <td>
                                            {report.cart_prospectos}
                                        </td>
                                        <td>
                                            {formatFloat(report.cart_prospectos_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuántos casos tienen en tubería?
                                        </td>
                                        <td>
                                            {report.cart_tuberia}
                                        </td>
                                        <td>
                                            {formatFloat(report.cart_tuberia_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuál es la estrategia para atraer a nuevos clientes?
                                        </td>
                                        <td colSpan={2}>
                                            {report.cart_estrategia}
                                        </td>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            2. Campaña de crédito
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            Revisión de créditos colocados durante el mes
                                        </td>
                                        <td>
                                            {report.cred_credito}
                                        </td>
                                        <td>
                                            {formatFloat(report.cred_credito_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Revisión de número de prospectos y montos
                                        </td>
                                        <td>
                                            {report.cred_prospectos}
                                        </td>
                                        <td>
                                            {formatFloat(report.cred_prospectos_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuántos casos tienen en tubería?
                                        </td>
                                        <td>
                                            {report.cred_tuberia}
                                        </td>
                                        <td>
                                            {formatFloat(report.cred_tuberia_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuál es la estrategia para atraer a nuevos clientes?
                                        </td>
                                        <td colSpan={2}>
                                            {report.cred_estrategia}
                                        </td>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            1. Preparación de visita
                                        </th>
                                    </tr>
                                    <tr>
                                        <td rowSpan={2}>
                                            ¿Se preparó adecuadamente la visita?
                                        </td>
                                        <td>
                                            {report.preparo_visita ? 'Sí' : 'No'}
                                        </td>
                                        <td>
                                            {report.preparo_visita_porque}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            {report.preparo_visita_comments}
                                        </td>
                                    </tr>

                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            2. Calificación de visita
                                        </th>
                                    </tr>

                                    <tr>
                                        <td rowSpan={2}>
                                            ¿Supo como romper el hielo con el cliente?
                                        </td>
                                        <td>
                                            {report.romper_hielo ? 'Sí' : 'No'}
                                        </td>
                                        <td>
                                            {report.romper_hielo_porque}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            {report.romper_hielo_comments}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowSpan={2}>
                                            ¿Generó compromisos con el cliente?
                                        </td>
                                        <td>
                                            {report.hizo_compromiso ? 'Sí' : 'No'}
                                        </td>
                                        <td>
                                            {report.hizo_compromiso_porque}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            {report.hizo_compromiso_comments}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Calificación general de la visita
                                        </td>
                                        <td colSpan={2}>
                                            {report.calificacion}
                                        </td>
                                    </tr>

                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            3. Comentarios al Broker
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            Retroalimentación al broker de la visita realizada
                                        </td>
                                        <td colSpan={2}>
                                            {report.feedback}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            : null
                        }
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>Fecha</th>
            <th>Título cita</th>
            <th>Número empleado</th>
            <th>Asesor</th>
            <th>Calificación</th>
            <th>Detalle</th>
        </tr>
    );
}

function renderRow(props) {
    const {item} = props;
    return (
        <tr>
            <td>
                {formatDatetime(item.event.datetime)}
            </td>
            <td>
                {item.event.title}
            </td>
            <td>
                {numberPadding(item.event.target.emp_number, 6)}
            </td>
            <td>
                {item.event.target.name}
            </td>
            <td>
                {item.calificacion}
            </td>
            <td>
                <button className="btn btn-sm btn-primary" onClick={() => props.showDetail(item)}>Detalle</button>
            </td>
        </tr>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/accompaniment/AccompanimentBroker.jsx
 **/